/**
 * @generated SignedSource<<b2efa2d79210773b0e0eb9a1102a395f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type recoilGetUnresolvedRemindersForPropertyBatchSubscription$variables = {
  property_batch_id: number;
};
export type recoilGetUnresolvedRemindersForPropertyBatchSubscription$data = {
  readonly sys_reminders: ReadonlyArray<{
    readonly package_report_id: number;
  }>;
};
export type recoilGetUnresolvedRemindersForPropertyBatchSubscription = {
  response: recoilGetUnresolvedRemindersForPropertyBatchSubscription$data;
  variables: recoilGetUnresolvedRemindersForPropertyBatchSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "property_batch_id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Literal",
            "name": "is_resolved",
            "value": {
              "_eq": false
            }
          },
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "_eq",
                "variableName": "property_batch_id"
              }
            ],
            "kind": "ObjectValue",
            "name": "property_batch_id"
          }
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "sys_reminders",
    "kind": "LinkedField",
    "name": "sys_reminders",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "package_report_id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "recoilGetUnresolvedRemindersForPropertyBatchSubscription",
    "selections": (v1/*: any*/),
    "type": "subscription_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "recoilGetUnresolvedRemindersForPropertyBatchSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8813e03dd252d570609fc803b764e0cb",
    "id": null,
    "metadata": {},
    "name": "recoilGetUnresolvedRemindersForPropertyBatchSubscription",
    "operationKind": "subscription",
    "text": "subscription recoilGetUnresolvedRemindersForPropertyBatchSubscription(\n  $property_batch_id: Int!\n) {\n  sys_reminders(where: {is_resolved: {_eq: false}, property_batch_id: {_eq: $property_batch_id}}) {\n    package_report_id\n  }\n}\n"
  }
};
})();

(node as any).hash = "357dd8a6f29db029a797fda220befbb4";

export default node;
